import React from "react";
import {
  flatFee,
  PublishingSplit,
  SideArtistClausesOptions,
  sideArtistServices,
} from "shared/components/AllDropdownOptions";
import {
  CustomAmountDropdown,
  CustomCalendar,
  CustomCheckbox,
  CustomDropDown,
  CustomInput,
  CustomTextArea,
  CustomTextInput,
} from "shared/components/allInput";
import CustomButton from "shared/components/inputButton";
import { handleChange } from "utils/TableFunctions";
import formValidation from "utils/validations";

const SideArtistTerms = ({ data, setData, onSideArtistSubmit }) => {
  console.log(data, "data");
  const handleChange = ({ name, value }) => {
    const formErrors = formValidation(name, value, data);
    setData((prev) => ({ ...prev, [name]: value, formErrors }));
  };

  const handleCurrencyChange = (newCurrencySymbol) => {
    setData((prev) => ({
      ...prev,
      currencySymbol: newCurrencySymbol,
    }));
  };

  return (
    <>
      <div className="ms:w-6">
        <h4 className="text-xl">Draft an Agreement</h4>
        <CustomInput
          data={data}
          name="agreementName"
          ignoreLabel
          col={12}
          onChange={handleChange}
        />
      </div>
      <div>
        <h5 className="text-xl font-medium">Primary Artist Name</h5>
        <div className="grid mt-3 align-items-center">
          <div className="md:col-5">
            <label className="text-gray-500" htmlFor="">
              Artist Full Legal Name
            </label>
            <CustomInput
              name="fullLegalName"
              placeholder="Enter Full Legal Name"
              data={data}
              ignoreLabel
              col={12}
              onChange={handleChange}
            />
          </div>
          <div className="col text-center">p/k/a</div>
          <div className="md:col-5">
            <label className="text-gray-500" htmlFor="">
              Artist Name
            </label>
            <CustomInput
              data={data}
              ignoreLabel
              name="name"
              col={12}
              onChange={handleChange}
            />
          </div>
          <div className="md:col-12">
            <h5 className="text-xl font-medium mb-3">Primary Artist Address</h5>
            <CustomTextArea
              col={12}
              className="w-full mt-3"
              rows={5}
              cols={30}
              data={data}
              ignoreLabel
              name="address"
              onChange={handleChange}
            />
          </div>
          <div className="md:col-12">
            <h5 className="text-xl font-medium mb-3">Side Artist Name</h5>
          </div>
          <div className="md:col-5">
            <label className="text-gray-500" htmlFor="">
              Side Artist Full Legal Name
            </label>
            <CustomInput
              name="sideArtistFullLegalName"
              data={data}
              ignoreLabel
              col={12}
              onChange={handleChange}
            />
          </div>
          <div className="col text-center ">p/k/a</div>
          <div className="md:col-5 ">
            <label className="text-gray-500 ">Side Artist Name</label>
            <CustomInput
              data={data}
              ignoreLabel
              col={12}
              name="sideArtistName"
              onChange={handleChange}
            />
          </div>
          <div className="md:col-12">
            <h5 className="text-xl font-medium mb-3">Side Artist Address</h5>
            <CustomTextArea
              className="w-full mt-3"
              rows={5}
              col={12}
              cols={30}
              data={data}
              name="sideArtistAddress"
              onChange={handleChange}
              ignoreLabel
            />
          </div>
          <div className="md:col-12">
            <h5 className="text-xl font-medium mb-3">Scope of Services</h5>
            <label className="text-gray-500" htmlFor="">
              Example: Recording Vocals and Co-producing
            </label>
            <CustomDropDown
              options={sideArtistServices}
              data={data}
              optionLabel="name"
              name="services"
              onChange={handleChange}
              ignoreLabel
            />
            {data.services === "Other" && (
              <div className=" md:col-12">
                <CustomTextArea
                  name="otherServices"
                  data={data}
                  placeholder="Description"
                  className="bg-white md:w-max-30rem"
                  ignoreLabel
                  onChange={handleChange}
                />
                <CustomInput
                  label="Project Name"
                  name="project"
                  data={data}
                  onChange={handleChange}
                />
              </div>
            )}
          </div>
          <div className="md:col-12">
            <h4 className="text-xl font-medium mb-3">Flat Fee</h4>
            <CustomDropDown
              options={flatFee}
              optionLabel="name"
              data={data}
              name="feeType"
              onChange={handleChange}
            />
          </div>
          <div className="md:col-6">
            <CustomAmountDropdown
              name="amount"
              extraClassName="w-full"
              data={data}
              currencyCode={data.currency}
              onCurrencyChange={handleCurrencyChange}
              onChange={handleChange}
            />
          </div>
          <div className="md:col-12">
            <label htmlFor="" className="font-bold">
              Royalties
            </label>
            <p className="">
              Royalties here means the royalty percentage of the net receipts of
              the release after all the expenses and recoupements related to the
              release
            </p>
            <CustomAmountDropdown
              name="royalty"
              data={data}
              className="w-full col-12"
              onChange={handleChange}
              showPercentageSymbol={true}
              inputplaceholder="Enter percentage"
            />
          </div>
          <div className="md:col-12">
            <h5 className="text-xl font-medium mb-3">Credit</h5>
            <CustomInput
              data={data}
              name="credit"
              col={6}
              onChange={handleChange}
              ignoreLabel
            />
          </div>
          <div className="md:col-12">
            <label htmlFor="" className="font-bold text-2xl">
              Accounting
            </label>
            <div className="flex md:flex-row flex-column align-items-center justify-content-center mt-2">
              <CustomInput
                data={data}
                label="Royalty Payment Timeline"
                name="royaltyPaymentTimeline"
                placeholder="Enter Days"
                col={6}
                onChange={handleChange}
              />
              <CustomInput
                data={data}
                name="royaltyThreshold"
                label="Minimum Royalty Threshold"
                placeholder="Enter Side Artist Royalty"
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="md:col-12">
            <label htmlFor="">Notice period for auditing</label>
            <div className="md:col-6 p-0">
              <CustomInput
                data={data}
                name="noticePeriod"
                placeholder="Enter Days"
                extraClassName="w-full"
                onChange={handleChange}
                ignoreLabel
              />
            </div>
          </div>
          <div className="md:col-12 ">
            <div className="md:col-6 p-0">
              <CustomInput
                data={data}
                name="approvalTime"
                label="Time for approval of ID  materials"
                extraClassName="w-full"
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="md:col-12">
            <h5 className="text-xl font-medium mb-3">
              Other Clauses to Add/Consider
            </h5>
            <p className="mb-2">
              Add any clauses that may be needed for your contract.
            </p>
            <div>
              <p className="mt-2 text-base font-semibold my-3 ">
                Warranties and representations:
              </p>
              <p className="text-lg font-normal">
                Is the Side Artist signed to a label exclusively.
              </p>
              <CustomDropDown
                name="labelWavier"
                options={PublishingSplit}
                data={data}
                optionLabel="name"
                ignoreLabel
                onChange={handleChange}
              />
              <br />
              <label htmlFor="" className="p-0  text-xl">
                Indemnification
              </label>
              <CustomCheckbox
                data={data}
                label="I accept"
                name="terminations"
                checked={true}
                disabled
                extraClassName="p-0"
              />
              <CustomTextArea
                name="indemnification"
                ignoreLabel
                placeholder="Any other comments"
                data={data}
                className="bg-white w-12 max-w-12"
                extraClassName="p-0"
                onChange={handleChange}
              />
              <label htmlFor="" className="text-xl">
                Notice
              </label>
              <CustomCheckbox
                data={data}
                label="I accept"
                name="terminations"
                checked={true}
                disabled
                extraClassName="p-0"
              />
              <CustomTextArea
                data={data}
                name="notice"
                className="bg-white w-12 max-w-12"
                extraClassName="p-0"
                placeholder="Any other comments"
                onChange={handleChange}
                ignoreLabel
              />
               <label htmlFor="" className="text-xl">
                Remedies
              </label>
              <CustomCheckbox
                data={data}
                label="I accept"
                name="terminations"
                checked={true}
                extraClassName="p-0"
                disabled
              />
              <CustomInput
                placeholder="Enter Jurisdiction Law"
                extraClassName="p-0"
                data={data}
                name="law"
                onChange={handleChange}
                ignoreLabel
              />
              <label htmlFor="" className="text-xl">Entire Contract</label>
              <CustomCheckbox
                data={data}
                label="I accept"
                name="terminations"
                checked={true}
                disabled
              />
              {data.labelWavier === "Yes" && (
                <div className="mt-2 border rounded shadow-sm bg-white">
                  <h2 className="text-lg font-semibold mb-4">
                    Exhibit A - Label Waiver
                  </h2>
                  <CustomCalendar
                    label="Effective Date"
                    placeholder="DD/MM/YYYY"
                    col={6}
                    name="effectiveDate"
                    value={
                      data?.effectiveDate ? new Date(data.effectiveDate) : null
                    }
                    data={data}
                    onChange={handleChange}
                  />
                  <CustomInput
                    label="Side Artist Label Name"
                    name="labelName"
                    placeholder="Enter Side Artist Label Name"
                    onChange={handleChange}
                    data={data}
                  />
                  <CustomInput
                    label="Address"
                    name="labelAddress"
                    placeholder="Enter Address"
                    onChange={handleChange}
                    data={data}
                  />
                  <CustomInput
                    label="Side Artist’s Name"
                    name="labelSideArtistName"
                    onChange={handleChange}
                    data={data}
                    placeholder="Enter Side Artist's Name"
                  />
                  <CustomInput
                    label="Address"
                    name="labelSideArtistAddress"
                    onChange={handleChange}
                    data={data}
                    placeholder="Enter Address"
                  />
                  <h4 className="mb-2">Wavier of Exclusive Rights</h4>
                  <label htmlFor="" className="p-1 mt-2">
                    Primary Artist's Name
                  </label>
                  <CustomInput
                    label="Primary Artist’s Name"
                    name="labelPrimaryArtistName"
                    onChange={handleChange}
                    extraClassName="p-0"
                    data={data}
                    placeholder="Enter primary Artist's Name"
                    ignoreLabel
                  />
                  <label htmlFor="" className="p-0 m-0 text-xl font-bold">
                    Grant for Rights
                  </label>
                  <CustomCheckbox
                    data={data}
                    label="I accept"
                    name="rights"
                    checked={true}
                    disabled
                    extraClassName="p-0"
                  />
                  <CustomTextArea
                    name="grantRights"
                    ignoreLabel
                    placeholder="Any other comments"
                    data={data}
                    className="bg-white w-12 max-w-12"
                    extraClassName="p-0"
                    onChange={handleChange}
                  />
                  <label htmlFor="" className="p-0 m-0 text-xl font-bold">
                    No Additional Obligations
                  </label>
                  <CustomCheckbox
                    data={data}
                    label="I accept"
                    name="rights"
                    checked={true}
                    disabled
                    extraClassName="p-0"
                  />
                  <CustomTextArea
                    name="additionalObligations"
                    ignoreLabel
                    placeholder="Any other comments"
                    data={data}
                    className="bg-white w-12 max-w-12"
                    extraClassName="p-0"
                    onChange={handleChange}
                  />
                  <label htmlFor="" className="p-0 m-0 text-xl font-bold">
                    Warrenties and representations
                  </label>
                  <CustomCheckbox
                    data={data}
                    label="I accept"
                    name="rights"
                    checked={true}
                    disabled
                    extraClassName="p-0"
                  />
                  <CustomTextArea
                    name="representations"
                    ignoreLabel
                    placeholder="Any other comments"
                    data={data}
                    className="bg-white w-12 max-w-12"
                    extraClassName="p-0"
                    onChange={handleChange}
                  />
                  <label htmlFor="" className="p-0 m-0 font-bold text-xl">
                    General Provisions
                  </label>
                  <p className="">
                    Governing Law – This Waiver shall be governed by and
                    construed in accordance with the laws of Jurisdiction.
                  </p>
                  <CustomInput
                    ignoreLabel
                    name="jurisdiction"
                    onChange={handleChange}
                    data={data}
                  />
                  <label htmlFor="" className="p-0 m-0">
                    Entire Contract
                  </label>
                  <CustomCheckbox
                    data={data}
                    label="I accept"
                    name="rights"
                    checked={true}
                    disabled
                    extraClassName="p-0"
                  />
                </div>
              )}
              <br />
              <CustomButton
                label="Generate contract"
                onClick={onSideArtistSubmit}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SideArtistTerms;
